__webpack_require__.p = "/iptagame/";